// DateRangePicker.tsx
import React from "react";
import { DateRangePickerProps } from "../types/revenue.types";

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  colorTheme,
}) => {
  return (
    <div
      style={{
        background: "white",
        padding: "20px",
        borderRadius: "12px",
        marginBottom: "24px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
        <div>
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: colorTheme.gray700,
              marginBottom: "4px",
            }}
          >
            Start Date
          </label>
          <input
            type="date"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            style={{
              padding: "8px 12px",
              border: `1px solid ${colorTheme.gray200}`,
              borderRadius: "6px",
              fontSize: "14px",
            }}
          />
        </div>
        <div>
          <label
            style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "500",
              color: colorTheme.gray700,
              marginBottom: "4px",
            }}
          >
            End Date
          </label>
          <input
            type="date"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            style={{
              padding: "8px 12px",
              border: `1px solid ${colorTheme.gray200}`,
              borderRadius: "6px",
              fontSize: "14px",
            }}
          />
        </div>
      </div>
    </div>
  );
};
